import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const PROGRAM_LABELS = {
  meditation_enlightenment: "Meditation Enlightenment",
  clarity_call: "Clarity Call",
  bliss_path: "Bliss Path Program",
  aura_night: "Aura Night Meditation",
  one_to_one: "iC One-to-One",
};

export const PROGRAM_SHORT = {
  meditation_enlightenment: "Enlightenment",
  clarity_call: "Clarity Call",
  bliss_path: "Bliss Path",
  aura_night: "Aura Night",
  one_to_one: "One-to-One",
};

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
}
